module.exports = __webpack_public_path__ + "static/media/en.6743b0e3.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/data/en.pdf
// module id = 713
// module chunks = 0